/* eslint-disable eqeqeq */
import React, { useEffect, useState, useContext } from "react";
import Navbar from "../header";
import Footer from "../footer";
import { useNavigate, useParams } from "react-router-dom";
import api, { API_URL, showAlert, AuthContext } from "../util/api";
import DepositCategory from "./crypto_payment/category";


export default function PaymentPage() {
    const [method, setMethod] = useState("card");
    const router = useNavigate();
    const { appointment_id } = useParams();
    const { User } = useContext(AuthContext);
    const [loading, setLoading] = useState(false);




    const payWithPaystack = (amount, reference, public_key) => {
        const handler = window.PaystackPop.setup({
            key: public_key, // PUBLIC KEY ONLY
            email: User.email,
            amount: amount, // kobo
            currency: "NGN",
            ref: reference,

            callback: function (response) {
                // 🔐 SEND REFERENCE TO BACKEND FOR VERIFICATION
                verifyPayment(response.reference);
            },

            onClose: function () {
                showAlert("info", "Payment cancelled", "You have cancelled the payment");
            },
        });

        handler.openIframe();
    };


    const verifyPayment = async (reference) => {
        try {
            const res = await api.get(`${API_URL}/paystack/verify?reference=${reference}`);
            const data = res.data;
            setLoading(true);

            if (data.status === "success") {

                router("/appointment/" + appointment_id);
                //showAlert("success", "Payment successful", "Your payment was successful");
            } else {
                showAlert("error", "error", data.message);
            }




        } catch (err) {

            showAlert("error", "Payment verification failed", "There was an error verifying your payment");
        } finally {
            setLoading(false);
        }
    };



    const CardPayment = async () => {
       
        //update the payment...  here  
         setLoading(true);
        const response = await api.get(`${API_URL}/initialize_payment/${appointment_id}`);

        let output = response.data;
         

        if (output.status == "success") {


            payWithPaystack(output.amount, output.reference, output.public_key);

            //window.location.href = output.authorization_url;

              setLoading(false);


            //router("/appointment/" + appointment_id);

        } else {

            showAlert('error', 'Error!', output.status.message);
            setLoading(false);
        }





    }

    const checkAppointment = async () => {
        try {

            //check if user is logged in
            if (!User) {
                showAlert("error", "Unauthorized", "Please log in to continue");
                router("/login");
                return;
            }
            const response = await api.get(`${API_URL}/check-appointment/${appointment_id}`);

            if (response.data.status !== 'success') {


                router("/");
            }



            if (response.data.appointment.status === "booked" || response.data.appointment.status === "completed") {

                router("/appointment/" + appointment_id);
                return;
            }

        } catch (error) {
            console.error("Error fetching doctors:", error);

        }

    }


    useEffect(() => {

        checkAppointment();
        //check if  appointment is already paid for or  exist  .  

    }, [])


    return (

        <>
            <Navbar menuColor="red" />

            <section >
                <div style={styles.container}>
                    <div style={styles.card}>
                        <h1 style={styles.title}>Payment Options</h1>

                        <div  align="center" style={styles.methodsRow}>
                            <button 
                                onClick={() => setMethod("card")}
                                style={{
                                    ...styles.methodBtn,
                                    ...(method === "card" ? styles.methodActive : {})
                                }}
                            >
                                💳 Card
                            </button>

                           {/*  <button
                                onClick={() => setMethod("crypto")}
                                style={{
                                    ...styles.methodBtn,
                                    ...(method === "crypto" ? styles.methodActive : {})
                                }}
                            >
                                🪙 Crypto
                            </button> */}
                        </div>

                        {method === "card" && (
                            <div style={{ animation: "fade .4s" }}>
                                <div style={styles.inputGroup}>
                                    {/* <input style={styles.input} placeholder="Cardholder Name" />
                    <input style={styles.input} placeholder="Card Number" />
                    <div style={styles.row2}>
                        <input style={styles.input} placeholder="MM/YY" />
                        <input style={styles.input} placeholder="CVV" />
                    </div> */}
                                </div>
                               

                                <button
                                    type="button"
                                    onClick={() => { if (!loading) CardPayment(); }}
                                    disabled={loading}
                                    style={{
                                        ...styles.payBtn,
                                        ...(loading ? { opacity: 0.6, cursor: "not-allowed" } : {})
                                    }}
                                >
                                    {loading ? "Processing..." : "Pay Now"}
                                </button>

                            </div>
                        )}

                        {method === "crypto" && (
                            <div style={{ animation: "fade .4s" }}>


                                <DepositCategory />


                                {/*  <div style={styles.walletBox}>
                                    Wallet Address:
                                    <p style={styles.walletCode}>0x1234...ABCD</p>
                                </div> */}
                                {/*  <button style={styles.payBtn}>I've Paid</button> */}
                            </div>
                        )}
                    </div>

                    {/* Inline styles */}
                    <style>
                        {`
                @keyframes fade { from {opacity: 0; transform: translateY(10px);} to {opacity: 1; transform: translateY(0);} }
                `}
                    </style>
                </div>

            </section>

            <Footer />

        </>
    );
}

const styles = {
    container: {
        minHeight: "100vh",
        background: "linear-gradient(135deg, #dfe9f3, #ffffff)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20
    },
    card: {
        width: "100%",
        maxWidth: 450,
        background: "white",
        borderRadius: 20,
        padding: 30,
        boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
    },
    title: {
        textAlign: "center",
        fontSize: 32,
        marginBottom: 25,
        fontWeight: "bold",
        color: "#1f3a61"
    },
    methodsRow: {
        display: "grid",
        gridTemplateColumns: "1fr",
        gap: 15,
        marginBottom: 25
    },
    methodBtn: {
        padding: "15px 10px",

        borderRadius: 15,
        border: "2px solid #d0d7e2",
        cursor: "pointer",
        color: "#1f3a61",
        background: "#f1f4f9",
        transition: "0.3s"
    },
    methodActive: {
        background: "#1f3a61",
        color: "white",
        borderColor: "#1f3a61",
        transform: "scale(1.05)"
    },
    inputGroup: {
        display: "grid",
        gap: 15
    },
    input: {
        padding: 14,
        borderRadius: 12,
        border: "1px solid #c7cfdb",
        fontSize: 16,
        width: "100%"
    },
    row2: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: 15
    },
    payBtn: {
        marginTop: 20,
        width: "100%",
        padding: 16,
        borderRadius: 15,
        background: "#1f3a61",
        color: "white",
        fontSize: 18,
        border: "none",
        cursor: "pointer",
        boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
        transition: "0.3s"
    },
    cryptoText: {
        fontSize: 16,
        textAlign: "center",
        marginBottom: 15
    },
    qr: {
        width: 150,
        height: 150,
        background: "#e0e0e0",
        borderRadius: 15,
        margin: "auto",
        marginBottom: 20
    },
    walletBox: {
        background: "#f1f4f9",
        padding: 15,
        borderRadius: 12,
        textAlign: "center",
        fontSize: 14,
        color: "#333",
        marginBottom: 20
    },
    walletCode: {
        marginTop: 5,
        fontFamily: "monospace",
        fontSize: 15,
        fontWeight: "bold"
    }
};
